export enum MaintenanceOrderRemarkScope {
  GSC = 0,
  ALL = 1,
}
